import { useEffect, useState } from "react";
import { useMapEvents } from "react-leaflet";
import distance from "../findDistance";
let module = require("../data.js");

function Mycomponent(props) {
  const [position, setposition] = useState({});
  const [nearH, setnearH] = useState({});
  let data = module.dataArr;
  // console.log(props.parentcallback);
  // distance(position.lat,position.lng,)
  function findnearestHospital() {
    let dist = Infinity;
    let index = "";
    data.forEach((hospital, ind) => {
      let displacement = distance(
        hospital.Lat,
        hospital.Lng,
        position.lat,
        position.lng,
        "K"
      );
      if (displacement < dist) {
        dist = displacement;
        index = ind;
      }
    });
    return [index, dist];
  }
  let setThings = () => {
    if (position.lat !== undefined) {
      let arrind = findnearestHospital();
      props.parentcallback(arrind);
      setnearH(data[arrind[0]]);
    }
  };

  //get latlng on mousemove
  const map = useMapEvents({
    mousemove: (e) => {
      //   console.log(e.latlng);
      setposition({ ...e.latlng });
    },
    mouseup: (e) => {
      // console.log(e.latlng);
      props.newMarker(e.latlng);
    },
  });

  useEffect(() => {
    setThings();
  }, [position]);

  return (
    <>
      {position.lat ? (
        <div className="latlng">
          <span>Latitude </span>
          <span style={{ marginLeft: "0.6rem" }}>
            {" "}
            : {position.lat.toFixed(6)}
          </span>
          <hr />
          <span>Longitude : {position.lng.toFixed(6)}</span>
        </div>
      ) : null}
      {nearH.Hospital_Names ? (
        <div className="nearH">
          <h3>Nearest Hospital</h3>
          <h4>{nearH.Hospital_Names.split(",")[0]}</h4>
          <p className="address">{nearH.Hospital_Names.split(",").slice(1)}</p>
        </div>
      ) : null}
    </>
  );
}

export default Mycomponent;
